import React, {ChangeEventHandler, ChangeEvent, forwardRef, useCallback} from 'react';
import TextField, {TextFieldProps} from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
import {IMask} from 'react-imask';
import csx from 'classnames';
import {omit} from 'lodash';

export type InputTextProps = Omit<TextFieldProps, 'inputRef'> & {
    parentClass?: string;
    mask?: IMask.AnyMasked | IMask.AnyMaskedOptions;
    value?: string;
    minMax?: {min: number; max: number};
};

export function createOnChangeMask(
    opts: IMask.AnyMasked | IMask.AnyMaskedOptions,
    prefix?: string,
): ChangeEventHandler<HTMLInputElement> {
    const mask = IMask.createPipe(opts, IMask.PIPE_TYPE.UNMASKED, IMask.PIPE_TYPE.MASKED);
    const unmask = IMask.createPipe(opts, IMask.PIPE_TYPE.MASKED, IMask.PIPE_TYPE.UNMASKED);

    return (e) => {
        e.target.value = `${(e.target.value.length !== 0 && e.target.value !== prefix && prefix) || ''}${mask(
            unmask(e.target.value),
        )}`;
    };
}

// eslint-disable-next-line react/function-component-definition
// eslint-disable-next-line prefer-arrow-callback
const InputText = forwardRef<any, InputTextProps>(function InputText(
    {parentClass, onChange, mask, value, prefix, ...props},
    ref,
) {
    const localOnChange = useCallback(
        (e: ChangeEvent<HTMLInputElement>) => {
            if (mask) createOnChangeMask(mask, prefix)(e);
            if (onChange) onChange(e);
        },
        [mask, onChange],
    );

    const inputProps = {
        ...(props?.minMax
            ? {
                  inputProps: {
                      max: 100,
                      min: 10,
                  },
              }
            : {}),
        ...(props?.InputProps ? props.InputProps : {}),
    };
    omit;
    return (
        <Box className={csx('p-related', parentClass)}>
            <TextField
                variant="outlined"
                {...omit(props, ['minMax'])}
                onChange={localOnChange}
                inputRef={ref}
                fullWidth
                value={value}
                InputProps={inputProps}
            />
        </Box>
    );
});

export default InputText;
